<template>
  <div class="page">
    <div class="d-flex">
      <search-bar
        style="flex: 1 0 auto;"
        @search="handleSearchBar"
        @typing="handleSearchTyping"
      ></search-bar>
      <div class="d-flex align-items-center ml-10">
        <action-button
          label="Add Group"
          :theme="{ primary, secondary, event, danger }"
          class="mt-0 d-inline-block w-auto"
          @customEvent="handleGroupCreate"
        />
      </div>
    </div>
    <div class="content--main">
      <div v-if="loaders.typing">Searching...</div>
      <div class="row" v-else>
        <div class="col-4 page--list-wrapper">
          <div class="page--list" v-scroll="onScroll">
            <Spinner :theme="primary" v-if="loaders.network" />
            <div v-else>
              <template v-if="items.length > 0">
                <widget
                  v-for="(item, i) of items"
                  :class="activeIndex == i ? 'active' : ''"
                  :details="generateWidgetDetails(item)"
                  :key="i"
                  @mouseover.native="hoveredWidget.push(item.id)"
                  @mouseleave.native="hoveredWidget.splice(1)"
                  :style="{
                    backgroundColor: hoveredWidget.includes(item.id)
                      ? secondary
                      : '#fafafa',
                    transition: 'background-color 0.2s ease'
                  }"
                  :widgets="item"
                  :active="hoveredWidget.includes(item.id) ? true : false"
                  @widgetClick="handleWidgetClick(i, item.id)"
                ></widget>
              </template>
              <div v-else>No results found.</div>
            </div>
          </div>
        </div>
        <div class="col-8 page--profile-wrapper">
          <div class="page--profile" v-if="activeGroup">
            <widget-details
              title="Group Details"
              :widgetOptions="widgetOptions"
              @deleteGroup="handleGroupDelete"
              @updateGroup="handleGroupUpdate"
            >
              <div class="d-flex">
                <div v-if="activeDetails.image" class="widget--avatar">
                  <img :src="activeDetails.image" :alt="activeDetails.title" />
                </div>
                <div v-else class="widget--avatar">
                  <span :style="{ backgroundColor: primary }">{{
                    activeDetails.title[0]
                  }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>{{ activeDetails.title }}</h4>
                  <p class="-muted" v-if="activeGroup.industry">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="company icon"
                      height="20"
                      width="20"
                    />{{ activeGroup.industry }}
                  </p>
                  <div class="row">
                    <div class="col">
                      <p v-if="activeGroup.companyEmail">
                        <img
                          src="~@/assets/media/icons/globe.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ activeGroup.companyEmail }}
                      </p>
                      <p v-if="activeGroup.phone">
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                          height="20"
                          width="20"
                        />{{ activeGroup.phone }}
                      </p>
                    </div>
                    <div class="col">
                      <p v-if="activeGroup.currentlyBooked">
                        <img
                          src="~@/assets/media/icons/company.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ activeGroup.currentlyBooked }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Member</h4></div>
                <div class="col px-0 text-right">
                  <ActionButton
                    label="Add a member"
                    :theme="{ primary, secondary, event, danger }"
                    class="mt-0 d-inline-block w-auto"
                    @customEvent="handleGroupAddMember"
                  />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="activeGroup.Users.length === 0">
                        <td colspan="2">
                          There are no group members found.
                        </td>
                      </tr>
                      <tr v-for="(member, i) in activeGroup.Users" :key="i">
                        <td>{{ member.firstName }} {{ member.lastName }}</td>
                        <td>
                          <a
                            :style="{ color: primary }"
                            href="javascript:void(0)"
                            @click="handleGroupViewMember(member)"
                            >View member</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </widget-details>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar";
import Widget from "@/components/Widget";
import Spinner from "@/components/Spinner";
import WidgetDetails from "@/components/WidgetDetails";
import ActionButton from "@/components/ActionButton";
import { mapActions, mapGetters } from "vuex";
import { socketSender } from "@/helpers/socket";

export default {
  name: "admin-groups",
  components: {
    ActionButton,
    SearchBar,
    Widget,
    Spinner,
    WidgetDetails
  },
  computed: {
    activeDetails() {
      return this.activeGroup
        ? this.generateWidgetDetails(this.activeGroup)
        : null;
    },
    activeGroup() {
      if (this.activeIndex > -1) {
        const user = this.items[this.activeIndex];
        return user;
      }
      return null;
    },
    items: {
      get() {
        return this.GET_GROUPS();
      }
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  data: () => ({
    activeIndex: 0,
    orders: [],
    loaders: {
      typing: false,
      network: true
    },
    widgetOptions: [
      {
        icon: "edit",
        label: "Edit Details",
        method: "updateGroup"
      },
      {
        icon: "Deactivate",
        label: "Deactivate",
        method: "deleteGroup"
      }
    ],
    hoveredWidget: []
  }),
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      GROUP_LIST_PAGINATE: "GROUP_LIST_PAGINATE",
      GROUP_LIST_RESET: "GROUP_LIST_RESET",
      GROUP_DELETE: "GROUP_DELETE"
    }),
    ...mapGetters({
      GET_GROUPS: "GET_GROUPS"
    }),
    async init() {
      this.action = "orderBy=name:ASC";
      this.GROUP_LIST_RESET();
      await this.GROUP_LIST_PAGINATE(this.action);
      this.loaders.network = false;
      this.hoveredWidget.push(this.items[this.activeIndex].id);
    },
    generateWidgetDetails(item) {
      return {
        image: item.image,
        title: item.name,
        subtitle:
          (item.Users ? item.Users.length : 0) +
          " - member" +
          (item.Users && item.Users.length > 1 ? "s" : "")
      };
    },
    handleGroupCreate() {
      const modal = "admin-companies-page-add-company";
      const name = "add-group";
      this.$emit("showModal", {
        modal,
        name,
        hasBackdropEvent: false
      });
    },
    handleGroupViewMember(member) {
      this.$emit("showModal", {
        modal: "admin-member-view-profile",
        name: "view-member-profile",
        member: member,
        singleRecord: this.activeGroup,
        hasBackdropEvent: false
      });
    },
    handleGroupAddMember() {
      this.$emit("showModal", {
        modal: "admin-companies-add-member",
        name: "add-group-member",
        singleRecord: this.activeGroup,
        hasBackdropEvent: false
      });
    },
    handleGroupUpdate() {
      const modal = "admin-companies-page-add-company";
      const name = "edit-group";
      const singleRecord = this.activeGroup;
      this.$emit("showModal", {
        modal,
        name,
        singleRecord,
        hasBackdropEvent: false
      });
    },
    handleGroupDelete() {
      this.$swal({
        title: "Do you want to deactivate this company?",
        type: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true
      }).then(result => {
        if (result.value == true) {
          socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} deactivated the company named ${this.activeGroup.name}`
          );
          this.GROUP_DELETE(this.activeGroup.id);
        }
      });
    },
    handleSearchTyping(value) {
      this.loaders.typing = value;
    },
    async handleSearchBar(word) {
      if (word) {
        this.action = `search[name]=${word}`;
      } else {
        this.action = "orderBy=name:ASC";
      }
      this.activeIndex = 0;
      this.GROUP_LIST_RESET();
      await this.GROUP_LIST_PAGINATE(this.action);
    },
    handleWidgetClick(index, id) {
      this.activeIndex = index;
      this.hoveredWidget = [];
      this.hoveredWidget.push(id);
    },
    onScroll(el, position) {
      let divScrollHeight = Math.floor(el.target.scrollHeight);
      let scrollCurrentHeight = Math.floor(
        position.scrollTop + el.target.offsetHeight
      );

      if (divScrollHeight === scrollCurrentHeight) {
        this.GROUP_LIST_PAGINATE(this.action);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./__users.scss";
@import "./__profile.scss";
</style>
